import type { ComponentProps } from "react";
import { joinClassNames } from "@/lib/classNames";
import styles from "./FormControls.module.css";

type SelectProps = ComponentProps<"select"> & {
  controlSize?: "default" | "compact";
};

export function Select({ className, controlSize = "default", ...props }: SelectProps) {
  return (
    <select
      data-slot="select"
      data-size={controlSize}
      className={joinClassNames(styles.control, styles.select, className)}
      {...props}
    />
  );
}
